import type React from 'react';
import SvgIcon from './SvgIcon';

const CheckCircle: React.FC = () => (
  <SvgIcon
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g id="CheckCircle">
      <path
        d="M9 0C13.97 0 18 4.03 18 9C18 13.97 13.97 18 9 18C4.03 18 0 13.97 0 9C0 4.03 4.03 0 9 0ZM9 2C5.14 2 2 5.14 2 9C2 12.86 5.14 16 9 16C12.86 16 16 12.86 16 9C16 5.14 12.86 2 9 2ZM13.7197 7.20996L8.71973 12.21C8.51975 12.3999 8.26971 12.5 8.00977 12.5C7.74987 12.4999 7.49973 12.4099 7.2998 12.21L4.2998 9.20996L5.70996 7.7998L8 10.0898L12.3096 5.7998L13.7197 7.20996Z"
        fill="#7B61FF"
      />;
    </g>
  </SvgIcon>
);

export default CheckCircle;
